/**
 * @module http
 */

interface QueryParams {
    redirect?: string;
    [key: string]: string | undefined;
}

export default parseQuery();

/**
 * @name parseQuery
 * @desc Parse location.search query into an object.
 * @param {{search:string}} param0
 * @returns {{}}
 * @public
 */
export function parseQuery(
    { search }: { search?: string } = window.location
): QueryParams {
    return (
        search
            ?.substring(1)
            .split('&')
            .reduce((query: QueryParams, item) => {
                const [key, value] = item.split('=');
                if (!key) {
                    return query;
                }
                query[key] = decodeURIComponent(value);
                return query;
            }, {}) || {}
    );
}
